import React, {Component, useState, useEffect} from 'react'
import {Redirect, Link} from 'react-router-dom';
import {Card, Input, Button} from 'antd'
import UserService from "../../API/user/UserService"
import PropTypes from 'prop-types';
import "./Register.css"
import Navbar from '../../components/layout/Navbar';
import Footer3 from '../../components/layout/Footer3';

const RegisterInner = (props) => {
    const [toast, setToast] = useState(null);

    useEffect(() => {
        if (!toast) return;
        const timer = setTimeout(() => setToast(null), 5000);
        return () => clearTimeout(timer);
    }, [toast]);

    return (
        <>
            <Navbar />
            <Register {...props} setToast={setToast} />
            {toast && (
                <div className="toast-notification-wrapper">
                    <div className={`toast-notification ${toast.type || 'error'}`}>
                        <div>
                            {toast.title && (
                                <div className="toast-notification-title">{toast.title}</div>
                            )}
                            <div>{toast.message}</div>
                        </div>
                        <button
                            type="button"
                            className="toast-notification-close"
                            onClick={() => setToast(null)}
                        >
                            ×
                        </button>
                    </div>
                </div>
            )}
            <Footer3 />
        </>
    );
};

class Register extends Component {
    constructor(props) {
        super(props)

        this.state = {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            nationalID: '',
            password: '',
            repassword: '',
            insurancePolicyNumber: '',
            isLoading: false,
            feedback: null,
            redirect: false
        }
    }


    static contextTypes = {
        encrypt: PropTypes.func.isRequired,
        decrypt: PropTypes.func.isRequired,
    }

    checkPassword = (password) => {
        if (password?.length > 8) {
            var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
            return re.test(password);
        } else {
            return false;
        }
    }


    submit = () => {
        this.setState({isLoading: true})
        if (this.state.firstName === '' || this.state.email === '' || this.state.password === '' || this.state.lastName === '') {
            this.setState({isLoading: false, feedback: "please include all fields"})
            this.props.setToast && this.props.setToast({
                type: 'error',
                title: 'Missing information',
                message: 'Please fill in all required fields.'
            });
        } else if (!this.state.email.includes('@') || !this.state.email.includes('.')) {
            this.setState({isLoading: false, feedback: "please enter a valid email"})
            this.props.setToast && this.props.setToast({
                type: 'error',
                title: 'Invalid email',
                message: 'Please enter a valid email address.'
            });
        } else if (!this.checkPassword(this.state.password)) {
            const msg = "Password must be at least 8 characters and include a number, a capital letter and a special character";
            this.setState({isLoading: false, feedback: msg})
            this.props.setToast && this.props.setToast({
                type: 'error',
                title: 'Weak password',
                message: msg
            });
        } else {
            UserService.registerUser({
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                password: this.state.password,
                phone: this.state.phone,
                nationalID: this.state.nationalID,
                insurancePolicyNumber: this.state.insurancePolicyNumber
            })
                .then((resp) => {
                    const msg = resp?.data?.message || "Email Sent";
                    this.setState({isLoading: false, feedback: msg})
                    this.props.setToast && this.props.setToast({
                        type: 'success',
                        title: 'Registration successful',
                        message: msg
                    });
                    this.setState({redirect: true})
                })
                .catch((err) => {
                    console.error('Registration error:', err?.response?.data || err);
                    const msg = 'Failed to register. Please try again later.';
                    this.setState({isLoading: false, feedback: msg});
                    this.props.setToast && this.props.setToast({
                        type: 'error',
                        title: 'Registration failed',
                        message: msg
                    });
                });
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }


    render() {

        if (this.state.redirect) {
            return <Redirect to={{
                pathname: `/verify`,
                state: {email: this.state.email}
            }}
            />
        }
        return (
            <div className='auth-page'>
                <div className='auth-card-wrapper register'>
                    <Card className='auth-card'>
                        <h1 className='auth-title'>Create Account</h1>
                        <p className='auth-subtitle'>
                            Fill in your details to register for an account
                        </p>

                        <div className='auth-row'>
                            <div className='auth-col'>
                                <div className='auth-form-group'>
                                    <label className='auth-label'>First Name</label>
                                    <Input
                                        placeholder='First name'
                                        name="firstName"
                                        className='auth-input'
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </div>
                            </div>
                            <div className='auth-col'>
                                <div className='auth-form-group'>
                                    <label className='auth-label'>Last Name</label>
                                    <Input
                                        name="lastName"
                                        placeholder='Last name'
                                        className='auth-input'
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className='auth-row'>
                            <div className='auth-col'>
                                <div className='auth-form-group'>
                                    <label className='auth-label'>Email</label>
                                    <Input
                                        placeholder='name@example.com'
                                        name="email"
                                        className='auth-input'
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </div>
                            </div>
                            <div className='auth-col'>
                                <div className='auth-form-group'>
                                    <label className='auth-label'>Phone</label>
                                    <Input
                                        placeholder='0782714222'
                                        className='auth-input'
                                        name="phone"
                                        type='phone'
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className='auth-row'>
                            <div className='auth-col'>
                                <div className='auth-form-group'>
                                    <label className='auth-label'>National ID</label>
                                    <Input
                                        type="text"
                                        placeholder='32197448A77'
                                        value={this.state.nationalID}
                                        className='auth-input'
                                        name="nationalID"
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </div>
                            </div>
                            <div className='auth-col'>
                                <div className='auth-form-group'>
                                    <label className='auth-label'>Account/Policy Number</label>
                                    <Input
                                        placeholder='Enter your policy number...'
                                        className='auth-input'
                                        value={this.state.insurancePolicyNumber}
                                        name="insurancePolicyNumber"
                                        type='text'
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className='auth-form-group'>
                            <label className='auth-label'>Create Password</label>
                            <Input
                                type="password"
                                placeholder='Enter password'
                                value={this.state.password}
                                className='auth-input'
                                name="password"
                                onChange={(e) => this.handleChange(e)}
                            />
                        </div>

                        <div className='auth-form-group'>
                            <label className='auth-label'>Re-enter Password</label>
                            <Input
                                type="password"
                                placeholder='Confirm password'
                                value={this.state.repassword}
                                name="repassword"
                                className='auth-input'
                                onChange={(e) => this.handleChange(e)}
                            />
                        </div>

                        <Button
                            onClick={this.submit}
                            type="primary"
                            className='auth-btn'
                        >
                            {this.state.isLoading ? (
                                <div className="lds-facebook"><div></div><div></div><div></div></div>
                            ) : (
                                <>Sign Up <span>&#8594;</span></>
                            )}
                        </Button>

                        {this.state.feedback && (
                            <p className='auth-feedback'>{this.state.feedback}</p>
                        )}

                        <div className='auth-footer'>
                            Already have an account? <Link to="/login">Sign in</Link>
                        </div>
                    </Card>
                </div>
            </div>
        )
    }
}


export default RegisterInner;
